// Geography helpers with no browser or server dependencies.

/** Great-circle distance in km (haversine). */
export function distanceKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const r = Math.PI / 180, x = Math.sin((lat2 - lat1) * r / 2) ** 2 + Math.cos(lat1 * r) * Math.cos(lat2 * r) * Math.sin((lon2 - lon1) * r / 2) ** 2;
  return 12742 * Math.asin(Math.sqrt(x));
}

/** Length of a route of [lat, lon, ...] points, km. */
export function trackKm(points: readonly (readonly number[])[]): number {
  let km = 0;
  for (let i = 1; i < points.length; i++) km += distanceKm(points[i - 1][0], points[i - 1][1], points[i][0], points[i][1]);
  return km;
}
